"use client";

import { motion } from "framer-motion";
import { useTrackModal } from "./top-5-tracks-list";

interface Top5TrackItemProps {
  trackName: string;
  children: React.ReactNode;
  type: "image" | "title";
}

export default function Top5TrackItem({
  trackName,
  children,
  type,
}: Top5TrackItemProps) {
  const { getLayoutId } = useTrackModal();

  return (
    <motion.div layoutId={getLayoutId(trackName, type)}>{children}</motion.div>
  );
}
